/**
 * Represents a subflow configuration.
 */
export class SubflowConfigurationWithShortName {
    static $inject = ['configurationName', 'subflowId', 'shortName'];
    /**
     * Constructor for SubflowConfigurationWithShortName class.
     * @param configurationName Name of sub flow configuration.
     * @param subflowId Id of Subflow.
     * @param shortName Name of sub flow configuration.
     */
    constructor(configurationName, subflowId, shortName) {
        this.configurationName = configurationName;
        this.subflowId = subflowId;
        this.shortName = shortName;
    }
}
